<script lang="ts" setup>
import AUApi from "@/api";
import { ref, onMounted, reactive, nextTick } from "vue";
import { showDialog } from "@/UIHelper";
import { calcFunctionNew } from "@/CalcHelperStatic";
import { Globals } from "@/Globals";
import { refreshFullPageContent } from "@/NavigationHelper";
import { globalsKennung, begriffBezeichnung } from "@/local";
import BaseEditor from "@/components/BaseEditor.vue";
import BaseApiAufruf from "@/views/Base/ApiAufruf.vue";
import {
  mountedBase,
  onSave,
  BaseSetup,
  reloadData,
  onDelete,
} from "@/DataLoaderStatic";
const emit = defineEmits(["back", "edit"]);
const props = defineProps<{
  modell?: string;
  modell1?: string;
  exportItems?: AbfrageItems[];
  pdf?: string;
  aic?: number;
  direction?: string;
  editDialog?: boolean;
  setEdit?: boolean;
  print?: boolean;
  printItems?: ALLDruck[];
  pers?: boolean;
  backOnSave?: boolean;
  queryEdit?: string;
}>();

function refreshItems(): void {
  throw new Error("Method not implemented.");
}
let editZeitbereich: APIZeitbereich | null = null;
let edit = ref<boolean>(false);
let showDialogLocal = ref<boolean>(false);
let hover = ref<boolean>(false);
let fab = ref<boolean>(false);
let transition: string = "scale-transition";
let showPrintMe = ref<boolean>(false);
let showExport = ref<boolean>(false);
let tooltip = ref<string>("");
let tooltip1 = ref<string>("");
let location = ref<any>("bottom center");

const pageParams: DataPageParameter = {
  zeitbereich: AUApi.Current.zeitbereich,
  insertMode: false,
  emitBack: () => emit("back"),
};
const uiData = reactive<DataPageUIData>(BaseSetup(pageParams));
onMounted(async () => {
  if (props.direction) {
    location.value = props.direction;
  }
  if (props.modell) {
    const begriffModell = globalsKennung(Globals.Begriff, props.modell);
    if (begriffModell) {
      tooltip = begriffModell.tooltip;
    }
  }
  if (props.modell1) {
    const begriffModell = globalsKennung(Globals.Begriff, props.modell1);
    if (begriffModell) {
      tooltip1 = begriffModell.tooltip;
    }
  }
});

async function backOrReload() {
  if (props.backOnSave) {
    emit("back", true);
  } else {
    await reloadData(uiData, pageParams);
  }
}
function onCalcFunction(modell: string, aic: number) {
  if (modell) {
    calcFunctionNew(modell, aic, false, onCalculated, editZeitbereich, []);
    setTimeout(() => refreshFullPageContent());
  }
}
function onCalculated(args?: any) {
  emit("back");
}
function openDruckVorschau(item: any) {
  const printItem = item;
  const aic = props.aic;
  const pers = props.pers;
  showDialog({
    title: printItem.bezeichnung,
    site: "BaseDruck",
    width: 500,
    data: { zeitbereich: AUApi.Current.zeitbereich, printItem, aic, pers },
    onClose: () => {
      return true;
    },
  });
}
</script>
<template>
  <div>
    <v-speed-dial
      :location="location"
      transition="fade-transition"
      :open-on-hover="hover"
      v-model="fab"
      class="pr-5"
    >
      <template v-slot:activator="{ props: activatorProps }">
        <v-fab
          variant="text"
          v-bind="activatorProps"
          :icon="fab ? 'mdi-menu-open' : 'mdi-dots-vertical'"
        >
        </v-fab>
        <!-- <v-btn v-model="fab" variant="text">
          <v-icon v-if="fab"> mdi-close </v-icon>
          <v-icon v-else>mdi-dots-vertical</v-icon>
        </v-btn> -->
      </template>
      <v-tooltip :disabled="!tooltip" location="bottom" :text="tooltip">
        <template v-slot:activator="{ props: tooltip }">
          <v-btn
            v-bind="tooltip"
            variant="flat"
            size="large"
            icon="mdi-check"
            v-if="props.modell && props.aic"
            @click="onCalcFunction(props.modell, props.aic)"
            color="warning"
          >
          </v-btn>
        </template>
      </v-tooltip>
      <v-tooltip :disabled="!tooltip1" location="bottom" :text="tooltip1">
        <template v-slot:activator="{ props: tooltip1 }">
          <v-btn
            v-bind="tooltip1"
            variant="flat"
            icon="mdi-close"
            size="large"
            v-if="props.modell1 && props.aic"
            @click="onCalcFunction(props.modell1, props.aic)"
            color="error"
          >
          </v-btn>
        </template>
      </v-tooltip>
      <v-btn
        v-if="props.setEdit && !edit"
        size="small"
        relative
        variant="text"
        icon="mdi-pencil-circle"
        @click="$emit('edit', true), (edit = true)"
      >
      </v-btn>
      <v-btn
        v-if="props.setEdit && edit"
        size="small"
        relative
        variant="text"
        icon="mdi-cancel"
        @click="$emit('edit', false), (edit = false)"
      >
      </v-btn>
      <v-btn
        color="blue"
        variant="text"
        icon="mdi-pencil"
        v-if="props.editDialog && props.aic"
        @click="showDialogLocal = true"
      >
      </v-btn>

      <v-btn
        variant="flat"
        icon="mdi-printer-outline"
        color="green"
        @click.stop="showPrintMe = !showPrintMe"
        v-if="props.print && props.printItems"
        size="large"
      >
      </v-btn>
      <v-btn
        variant="flat"
        icon="mdi-swap-vertical"
        color="info"
        size="large"
        @click.stop="showExport = !showExport"
        v-if="props.exportItems && props.exportItems.length > 0"
        style="z-index: 99999"
      >
      </v-btn>
    </v-speed-dial>
    <v-dialog leave-absolute="true" max-width="450px" v-model="showDialogLocal">
      <BaseEditor
        @back="showDialogLocal = false"
        :query="props.queryEdit"
        :aic="props.aic"
        fieldCssClass="md12"
        :showTitle="false"
        :showDeleteButton="false"
      />
    </v-dialog>
    <v-dialog
      leave-absolute="true"
      max-width="450px"
      max-height="300px"
      v-model="showPrintMe"
      scrollable

    >
      <v-card>
        <v-list>
          <v-list-item
            v-for="(printItem, ux) in props.printItems"
            :key="'ui' + ux"
            @click="openDruckVorschau(printItem)"
          >
            <v-tooltip
              :disabled="!tooltip"
              location="bottom"
              :text="printItem.tooltip"
            >
              <template v-slot:activator="{ props }">
                <v-list-item-title v-bind="props">
                  {{ printItem.bezeichnung }}
                </v-list-item-title>
              </template>
            </v-tooltip>
          </v-list-item>
        </v-list>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            class="pa-0"
            @click="showPrintMe = false"
            variant="text"
            prepend-icon="mdi-close"
            :text="begriffBezeichnung('Close')"
          >
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      leave-absolute="true"
      max-width="600px"
      v-model="showExport"
      scrollable
    >
      <BaseApiAufruf
        @back="showExport = false"
        :exportAbfragen="props.exportItems"
        title="Export"
        type="month"
      >
      </BaseApiAufruf>
    </v-dialog>
  </div>
</template>
<style scoped>
.v-btn.v-size--small {
  min-width: 100%;
  padding: 0px;
}
.v-speed-dial {
  position: absolute;
}
.v-btn--floating {
  position: relative;
}
</style>
